import { useParams } from 'react-router-dom';
import { useFileInfoQuery } from '../data/useFileInfoQuery';
import { Loader } from 'components/UI/Loader';

export const BackendFileFromDiff = ({
	fileId,
	variableName
}: {
	fileId: string;
	variableName: string;
}) => {
	const params = useParams();
	const projectId = params.projectId as string;
	const entryId = params.entryId as string;

	const fileInfoQuery = useFileInfoQuery({
		entryId,
		projectId,
		fileId
	});

	if (fileInfoQuery.isLoading) {
		return <Loader />;
	}

	let filename: string | undefined;
	if (fileInfoQuery.data?.doc.metadata.fileName) {
		filename = fileInfoQuery.data.doc.metadata.fileName;
	}

	return (
		<p
			data-testid={`diffed-backend-file-field_${variableName}`}
			className="text-sm font-semibold"
		>
			{filename || 'File not found'}
		</p>
	);
};
